<template>
  <div class="ecm__explores section__padding">
    <h1 class="ecm__explores--title section--title">
      <span>{{ title }}</span>
    </h1>
    <div class="ecm__explores-items">
      <button
        v-for="item in items" :key="item.id" class="ecm__explores-items--item"
        @click="handleMove(item.name)"
        >
        {{ item.name }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Explores',
  props: {
    title: {
      type: String
    },
    items: {
      type: Array
    },
    keyData: {
      type: String
    }
  },
  methods: {
    handleMove (contentName) {
      let query = ''
      switch (this.$props.keyData) {
        case 'category':
          query = `?category=${contentName}`
          break
        case 'author':
          query = `?author=${contentName}`
          break
        case 'publisher':
          query = `?publisher=${contentName}`
          break
        default:
          query = ''
          break
      }
      this.$router.push(`/books${query}`)
        .catch((e) => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__explores {
  .ecm__explores--title {
    color: var(--color-blue-background);
    font-size: 15px;
    span {
      font-weight: 550;
      border-radius: 22px;
      padding: 3px 20px;
      background: var(--color-yellow);
    }
  }
  .ecm__explores-items {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 15px;
    .ecm__explores-items--item {
      background: none;
      outline: none;
      border: 1px solid var(--color-blue-background);
      padding: 3px 12px;
      border-radius: 22px;
      color: var(--color-blue-background);
      font-weight: 500;
      cursor: pointer;
      font-size: 13px;
      margin-bottom: 7px;
      transition: ease-out .1s;
      &:not(:last-child) {
        margin-right: 7px;
      }
      &:hover {
        background: var(--color-blue-background);
        color: white;
      }
    }
  }
}
</style>